var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreCourseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6992 25.1259V26.9604C22.6992 27.5642 22.2092 28.0542 21.6055 28.0542C21.0017 28.0542 20.5117 27.5642 20.5117 26.9604V25.1375H22.3346C22.4571 25.1375 22.5782 25.1331 22.6992 25.1259Z",
    fill: "#58BCAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5117 25.1375H10.668C7.64776 25.1375 5.19922 22.689 5.19922 19.6688V15.1742L13.5321 19.7782C15.3376 20.7757 17.6651 20.7757 19.4705 19.7782L20.5117 19.2036V25.1375ZM22.6992 17.9946L27.8034 15.1742V19.6688C27.8034 22.5665 25.5503 24.9377 22.6992 25.1259V17.9946Z",
    fill: "#FFC22E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5117 17.5367L18.7646 18.5021C17.388 19.2633 15.6146 19.2633 14.238 18.5021L2.11339 11.8025C1.28797 11.346 0.824219 10.5469 0.824219 9.71126C0.824219 8.87417 1.28797 8.07501 2.11339 7.62001L14.238 0.918965C15.6146 0.159173 17.388 0.159173 18.7646 0.918965L30.8892 7.62001C31.7146 8.07501 32.1784 8.87417 32.1784 9.71126C32.1784 10.5469 31.7146 11.346 30.8892 11.8025L22.6992 16.3277V15.2938C22.6992 15.0036 22.584 14.725 22.3784 14.5208L17.2742 9.41667C16.8484 8.98938 16.1542 8.98938 15.7284 9.41667C15.3011 9.84251 15.3011 10.5367 15.7284 10.9625L20.5117 15.7473V17.5367Z",
    fill: "#58BCAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreCourseIcon);
export default __webpack_public_path__ + "static/media/gre-course-icon.dda4bbcfdd94c408a7f0ae90b709ae18.svg";
export { ForwardRef as ReactComponent };